import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ContainersService } from 'src/app/providers/services/containers.service';
import { IContainerModel } from 'src/app/storage/interfaces/container-model.interface';
import { ITransportCompany } from 'src/app/storage/interfaces/transport-company.interface';
import { Container } from 'src/app/storage/models/container.model';
import { Market } from 'src/app/storage/models/market.model';

@Component({
    selector: 'app-create-container',
    templateUrl: './create-container.component.html',
    styleUrls: ['./create-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateContainerComponent implements OnInit {
  form: UntypedFormGroup;

  containerModels: IContainerModel[];
  transportCompanies: ITransportCompany[];

  @Input() market: Market
  @Output() closeModal = new EventEmitter<any>();

  constructor(
    private containersService: ContainersService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.form = new UntypedFormGroup({
      containerId: new UntypedFormControl('', [Validators.required]),
      containerMAWP: new UntypedFormControl('', [Validators.required, this.numberValidator()]),
      containerMaxCapacity: new UntypedFormControl('', [Validators.required, this.numberValidator()]),
      containerTareWeight: new UntypedFormControl('', [Validators.required, this.numberValidator()]),
      containermodelName: new UntypedFormControl('', [Validators.required]),
      transportcompanyName: new UntypedFormControl('', [Validators.required]),
      containerPumpCarrier: new UntypedFormControl('', [])
    });

    this.containerModels = await this.containersService.getContainerModels();
    this.transportCompanies = await this.containersService.getTransportCompanies();

    if (this.containerModels == null || this.transportCompanies == null) { this.close(); }
  }

  close(): void {
    this.closeModal.emit();
  }

  numberValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const value = control.value;
      if (isNaN(value)) {
        return {wrongFormat: {value: control.value}};
      }
      return null;
    }
  }

  async create(): Promise<void> {
    const controls = this.form.controls;
    const form = Object.keys(controls).reduce((acc, controlKey) => {
      acc[controlKey] = controls[controlKey].value;
      return acc;
    }, { });

    const container = new Container({
      containerpk: null,
      containerId: controls['containerId'].value,
      containerMAWP: controls['containerMAWP'].value,
      containerMaxCapacity: controls['containerMaxCapacity'].value,
      containerMaxWeight: null,
      containerPumpCarrier: controls['containerPumpCarrier'].value === true ? 1 : 0,
      containerTareWeight: controls['containerTareWeight'].value,
      transportcompanyName: controls['transportcompanyName'].value,
      containermodelName: controls['containermodelName'].value,
      weightThreshold: null,
      deletionFlag: null
    });

    const containerIsAdded = await this.containersService.addContainer(this.market.marketname, container);

    if (containerIsAdded) { this.closeModal.emit(container); }
  }

}
